import { type ReactNode } from 'react';
import { Button, Icon } from '@ics-portal/guardian';
import { getProjectIcon } from '@utils/projectType';
import { ProjectMarkerIcon } from '@components/_atoms/projectMarkerIcon';
import { useMapContext } from '@pages/map/_utils/map-context';
import { getProjectStatus } from '@pages/map/_utils/utils';
import s from '../project-details-box.module.scss';

export function ProjectDetailsInfo(): ReactNode {
    const { project, setProject } = useMapContext();
    if (!project) {
        return null;
    }
    return (
        <div className="flex flex-column gap-4 align-items-stretch">
            <div className="flex align-items-start justify-content-between gap-4">
                <h2>{project.name}</h2>
                <Button
                    icon={<Icon name="close" />}
                    onClick={() => {
                        setProject(null);
                    }}
                />
            </div>
            <div className="flex justify-content-between align-items-start">
                <div>
                    <h2 className={s.customerName}>{project.customerName}</h2>
                    <p>{project.type?.name}</p>
                    {Boolean(project.organization?.name) && (
                        <p className={s.projectOrganizationName}>
                            {project.organization?.name}
                        </p>
                    )}
                </div>
                <div className="flex">{getProjectIcon(project.type?.id)}</div>
            </div>
            <div className={`flex justify-content-end ${s.projectStatus}`}>
                {project.status?.name} - {project.milestone?.name}{' '}
                <ProjectMarkerIcon
                    variant="small"
                    status={getProjectStatus(project.status?.name)}
                />
            </div>
        </div>
    );
}
